import React from 'react';
import { Outlet } from 'react-router-dom';
import { initialInsuranceJourneyState } from '../../../consts/Common';
import {
  InsuranceJourneyContext,
  InsuranceJourneyState
} from '../../common/CommonTypes';
import { useContext, useReducer, useEffect } from 'react';
import InsuranceJourneyReducer from '../../../journeyState/InsuranceJourney/InsuranceJourneyReducer';
import { PersonalDetailsPageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/PersonalDetailsPage';
import { DrivingHistoryDetailsPageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/DrivingHistoryDetailsPage';
import { VehicleDetailsPageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/VehicleDetailsPage';
import NavBar from '../../common/NavBar';
import { SiteContext } from '../../../context/SiteContext';
import { AdditionalDriverDetailsPageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/AdditionalDriverDetailsPage';
import { CoverDetailsPageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/CoverDetailsPage';
import { ConfirmationDetailsPageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/ConfirmationDetailsPage';
import { CommonPageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/Common';
import { AddressDetailsPageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/AddressDetailsPage';
import { AboutTermsOfBusinessAndFairUsePageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/AboutTermsOfBusinessAndFairUsePage';
import { ImportantNoticeInformationPageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/ImportantNotinceInformationPage';
import '../../../styles/insurance.scss';
import { PaymentPageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/PaymentPage';
import { YourQuotePagePageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/YourQuotePage';
import { OptioanlCoverPageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/OptionalCoverPage';
import useCarInsuranceController from '../../../hooks/insuranceJourney/useCarInsuranceController';
import { DealerLoginPageEventHandlers } from '../../../journeyState/InsuranceJourney/Actions/DealerLoginPage';
import InsuranceErrorPage from './InsuranceErrorPage';
import { ErrorBoundary } from 'react-error-boundary';

const InsuranceJourneyManager = (): JSX.Element => {
  const { site } = useContext(SiteContext);
  const [journey, dispatch] = useReducer(
    InsuranceJourneyReducer,
    initialInsuranceJourneyState
  );

  const { getNewQuote } = useCarInsuranceController();

  useEffect(() => {
    const getNewQuoteSuccess = (quote: InsuranceJourneyState) => {
      dispatch({
        type: 'set-quote',
        quote: {
          ...quote,
          tiaProductCode: site.brand.tiaProductCode
        }
      });
    };

    const getNewQuoteFailure = (error: string) => {
      console.log('quote error - ' + error);
    };

    getNewQuote(
      site.brand.brandName,
      site.user?.insuranceDealerCode ?? '',
      site.user.token,
      getNewQuoteSuccess,
      getNewQuoteFailure
    );
  }, []);

  const {
    personalDetails,
    drivingHistoryDetails,
    vehicleInfo,
    coverDetails,
    additionalDriverDetails,
    confirmationDetails,
    addressDetails,
    aboutTermsOfBusinessAndFairUseDetails,
    importantNoticeInformationDetails,
    paymentDetails,
    insuranceProducts
  } = journey;

  const insuranceJourneyContext: InsuranceJourneyContext = {
    journey: journey,
    pageEvents: {
      personalDetailsPage: PersonalDetailsPageEventHandlers(
        personalDetails,
        dispatch
      ),
      drivingHistoryDetailsPage: DrivingHistoryDetailsPageEventHandlers(
        drivingHistoryDetails,
        dispatch
      ),
      vehicleDetailsPage: VehicleDetailsPageEventHandlers(
        vehicleInfo,
        dispatch
      ),
      coverDetailsPage: CoverDetailsPageEventHandlers(coverDetails, dispatch),
      additionalDriverDetailsPage: AdditionalDriverDetailsPageEventHandlers(
        additionalDriverDetails,
        dispatch
      ),
      yourQuotePage: YourQuotePagePageEventHandlers(
        insuranceProducts,
        dispatch
      ),
      optionalCoverPage: OptioanlCoverPageEventHandlers(
        insuranceProducts,
        dispatch
      ),

      confirmationDetailsPage: ConfirmationDetailsPageEventHandlers(
        confirmationDetails,
        dispatch
      ),
      commonEvents: CommonPageEventHandlers(dispatch),
      addressDetailsPage: AddressDetailsPageEventHandlers(
        addressDetails,
        dispatch
      ),
      aboutTermsOfBusinessAndFairUseDetailsPage:
        AboutTermsOfBusinessAndFairUsePageEventHandlers(
          aboutTermsOfBusinessAndFairUseDetails,
          dispatch
        ),
      importantNoticeInformationDetailsPage:
        ImportantNoticeInformationPageEventHandlers(
          importantNoticeInformationDetails,
          dispatch
        ),
      paymentPage: PaymentPageEventHandlers(paymentDetails, dispatch),
      dealerLoginPage: DealerLoginPageEventHandlers(dispatch)
    }
  };

  return (
    <div className='insurance'>
      <div className={`insurance-${site.brand.brandName}`}>
        <NavBar setQuote={dispatch} />
        <ErrorBoundary FallbackComponent={InsuranceErrorPage}>
          <Outlet context={insuranceJourneyContext} />
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default InsuranceJourneyManager;
